import { Stack } from '@mui/material';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import React from 'react';
import {
	PROTECTED_COMPONENT_ERROR,
	PROTECTED_COMPONENT_ERROR_TITLE,
	PROTECTED_COMPONENT_PERMISSIONS_REQUIRED_TITLE,
} from '../data/constants';
import { Permission } from '../permissions';

interface ProtectedComponentProps {
	permission: Permission | Permission[];
}

const ProtectedComponent: React.FC<ProtectedComponentProps> = ({
	permission,
}) => {
	return (
		<Alert severity='warning'>
			<Stack spacing={1} direction='column'>
				<Typography fontWeight={500}>
					{PROTECTED_COMPONENT_ERROR_TITLE}
				</Typography>
				<Typography variant='body2'>{PROTECTED_COMPONENT_ERROR}</Typography>
				<Typography variant='body2'>
					{PROTECTED_COMPONENT_PERMISSIONS_REQUIRED_TITLE}
					{Array.isArray(permission) ? permission.join(', ') : permission}
				</Typography>
			</Stack>
		</Alert>
	);
};

export default ProtectedComponent;
